module.exports = __webpack_public_path__ + "static/media/teacher.9b68f8db.png";